import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../DashboardLeftMenu';
import { HOST_URL } from '../api/Api';
import Axios from '../../../axios/Axios';
import { handleUserLog } from '../../Utils/Utils';

class NotificationStatus extends Component {

constructor () {

const lStorage = JSON.parse(localStorage.getItem("login"));
const userId= lStorage.user.userId;
const userToken= lStorage.token;

super();
    this.state = {
        user_id:userId,
        token:userToken,
        DailyUsageStatus:false,
        LowBalanceStatus:false,
        LowBalanceAmount:'',
        errorMessage:'',
        successMessage:false,
        bgColor:''
    }
}


componentDidMount() {
    this.getUserStatus()
}

getUserStatus() {
  Axios
    .post(`${HOST_URL}/profile.php`, {
      user_id: this.state.user_id,
      method: "retrieve",
      token: this.state.token,
    })
    .then((response) => {
      const result = response.data;
      if (result.success === true) {
        const data = result.data[0];

        this.setState({
          DailyUsageStatus: data.is_daily_usage === 1,
          LowBalanceAmount: data.low_balance_val,
          LowBalanceStatus: data.is_low_balance === 1,
        });
      }
    })
    .catch((error) => {
      console.error("Error fetching user status:", error);
    });
}

updateStatus() {
  let DailyUsagestatus = this.state.DailyUsageStatus ? 1 : 0;
  let LowBalance = this.state.LowBalanceStatus ? 1 : 0;

  // 1st API - Manage Daily Usage
  Axios
    .post(`${HOST_URL}/manage_daily_usage_report.php`, {
      user_id: this.state.user_id,
      status: DailyUsagestatus,
      token: this.state.token,
    })
    .then((response) => {
      const result = response.data;
      this.setState({
        successMessage: true,
        bgColor: result.success
          ? "alert alert-success alert-dismissible"
          : "alert alert-danger alert-dismissible",
        errorMessage: result.data,
      });
      handleUserLog("", "update_save_button", "notification_status", "Daily usage report status updated", "notification_status", "", { status: DailyUsagestatus })
    })
    .catch((error) => {
      console.error("Error updating daily usage status:", error);
    });

  // 2nd API - Manage Low Balance
  Axios
    .post(`${HOST_URL}/manage_low_balance_report.php`, {
      user_id: this.state.user_id,
      status: LowBalance,
      amount: this.state.LowBalanceAmount,
      token: this.state.token,
    })
    .then((response) => {
      const result = response.data;
      this.setState({
        successMessage: true,
        bgColor: result.success
          ? "alert alert-success alert-dismissible"
          : "alert alert-danger alert-dismissible",
        errorMessage: result.data,
      });
      handleUserLog("", "update_save_button", "notification_status", "Low balance alert status updated", "notification_status", "", { status: LowBalance, amount: this.state.LowBalanceAmount })

      if (result.success) {
        setTimeout(() => {
          window.location = "/dashboard/notification";
        }, 2000);
      }
    })
    .catch((error) => {
      console.error("Error updating low balance status:", error);
      handleUserLog("", "update_save_button", "notification_status", "Error updating low balance status", "notification_status", "", { status: LowBalance, amount: this.state.LowBalanceAmount })
    });
}



toggleDailyStatus = () => {
    this.setState({ DailyUsageStatus: !this.state.DailyUsageStatus }) 
}

toggleLowBalance = () => {
    this.setState({ LowBalanceStatus: !this.state.LowBalanceStatus }) 
}


render() {
    return (
<div className="wrapper">
    <DashboardLeftMenu />
        <div className="main">
            <DashboardHeader />
            <main className="content">
                <div className="container-fluid p-0">
                    <div className="row mb-2 mb-xl-3">
                        {/* <div className="col-auto d-none d-sm-block">
                            <h3><strong>Notification </strong> Setup </h3>
                        </div> */}
                          <nav className="text-center" aria-label="breadcrumb">
                                                    <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                        <Link to="view-all-notifications" onClick={() => handleUserLog("", "notifications_tab", "notification_status", "User Click on Notifications tab", "notification_status", "", "")}><li className="breadcrumb-item ">Notifications </li> </Link>
                                                        <Link to="notification" onClick={() => handleUserLog("", "notification_setup_tab", "notification_status", "User Click on Notification Setup tab", "notification_status", "", "")}> <li className="breadcrumb-item active ">Notification Setup </li> </Link>
                                                    </ol>
                                                </nav>
                    </div>
                    <div className="row">
                    
                    {
                        this.state.successMessage? 
                        <div className={this.state.bgColor} role="alert">
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">×</span>
                            </button>
                            <div className="">
                                {this.state.errorMessage}
                            </div>
                        </div>
                        :
                        null
                    }

                    <div className="card">
                        <div className="card-body">   

                        
                        <div className="notification-list">
                            <p>Get Daily Usage Reports on your email </p>
                            <label className="switch">
                            <input
                            type="checkbox"
                            onChange={this.toggleDailyStatus}
                            checked={this.state.DailyUsageStatus}
                            />
                            <span className="slider round"></span>
                            </label>
                        </div>
                        <hr className="mt-0 mb-2" />
                        <div className="notification-list">
                            <p> Low Balance Alert Email </p>
                            <p>Enter Low Balance Threshold:
                            
                            <input
                                 type="text" style={{width:200+'px',height:20+'px'}} 
                                 onChange={(event) => this.setState({ LowBalanceAmount: event.target.value})}
                                 defaultValue={this.state.LowBalanceAmount}
                                 className="form-control"
                            /></p>

                            <label className="switch">
                            <input
                            type="checkbox"
                            onChange={this.toggleLowBalance}
                            checked={this.state.LowBalanceStatus}
                            />
                            <span className="slider round"></span>
                            </label>
                        </div>

                        <hr className="mt-0 mb-0" />
                        <div className="text-right d-block">
                         <button onClick={()=> {
                            handleUserLog("", "update_save_button", "notification_status", "User click on Update and Save button", "notification_status", "", { daily_usage: this.state.DailyUsageStatus, low_balance: this.state.LowBalanceStatus });
                            this.updateStatus();
                         }} className="btn btn-sm mt-4 btn-primary">Update and Save </button>
                        </div>
                         
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <DashboardFooter />
    </div>
</div>
        );
    }
}

export default NotificationStatus;